export default "__VITE_ASSET__FtbZGe9z__"